import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account created!");
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20">
      <div className="bg-white border border-[#E8E4D9] rounded-2xl p-8">
        <h1 className="text-3xl font-bold tracking-tight text-[#1A231C] font-display">Create account</h1>
        <p className="text-[#5C665D] mt-2">Sign up to track your orders.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input
            data-testid="register-name"
            required
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            placeholder="Full name"
            className="w-full bg-white border border-[#E8E4D9] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--brand-primary)] focus:ring-1 focus:ring-[var(--brand-primary)]"
          />
          <input
            data-testid="register-email"
            type="email"
            required
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder="Email"
            className="w-full bg-white border border-[#E8E4D9] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--brand-primary)] focus:ring-1 focus:ring-[var(--brand-primary)]"
          />
          <input
            data-testid="register-password"
            type="password"
            required
            minLength={6}
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            placeholder="Password (min 6 chars)"
            className="w-full bg-white border border-[#E8E4D9] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--brand-primary)] focus:ring-1 focus:ring-[var(--brand-primary)]"
          />
          {error && (
            <p data-testid="register-error" className="text-sm text-[var(--brand-accent)]">
              {error}
            </p>
          )}
          <button
            data-testid="register-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[var(--brand-primary)] text-white rounded-lg px-6 py-3 font-medium hover:bg-[var(--brand-primary-hover)] transition-colors disabled:opacity-60"
          >
            {loading ? "Creating..." : "Sign up"}
          </button>
        </form>
        <p className="text-sm text-[#5C665D] mt-5 text-center">
          Already have an account?{" "}
          <Link to="/login" data-testid="go-login" className="text-[var(--brand-primary)] font-medium">
            Login
          </Link>
        </p>
      </div>
    </div>
  );
}
